import { createAction } from '@reduxjs/toolkit';
import { stateName } from '../constants';
export const selectCreditCardRequest = createAction("".concat(stateName, "/selectCreditCardRequest"));